import axios from 'axios';

// export const serverURL = 'http://123.206.198.189:3300';
// export const serverURL = 'http://210.14.78.146:8600';
// export const serverURL = 'http://119.3.15.153:8100/XF';
// export const serverURL = 'http://119.3.15.153:8100/CTD';
// export const serverURL = 'http://119.3.15.153:8100/HJ';
export const serverURL = 'http://119.3.15.153:8100/NGS';
// export const serverURL = 'http://119.3.15.153:8100/HQYY';
// export const serverURL = 'http://119.3.15.153:8600';
// export const serverURL = 'http://111.231.77.219:3400/YYGY';
// export const serverURL = 'http://localhost:8080';
export const baseURL = serverURL + "/api";

export const webapi = axios.create({
  baseURL: baseURL,
  // baseURL: 'http://localhost:8080/api',
  headers: {
    Authorization: 'Bearer ' + window.localStorage.getItem("token")
  }
})

let base = '';

export const requestLogin = params => {
  return axios.post(`${base}/login`, params).then(res => res.data);
};

export const getUserList = params => {
  return axios.get(`${base}/user/list`, {params: params});
};

export const getUserListPage = params => {
  return axios.get(`${base}/user/listpage`, {params: params});
};

export const removeUser = params => {
  return axios.get(`${base}/user/remove`, {params: params});
};

export const batchRemoveUser = params => {
  return axios.get(`${base}/user/batchremove`, {params: params});
};

export const editUser = params => {
  return axios.get(`${base}/user/edit`, {params: params});
};

export const addUser = params => {
  return axios.get(`${base}/user/add`, {params: params});
};



// WEBPACK FOOTER //
// ./src/api/api.js